'use client';

import { useEffect } from 'react';
import { usePhrasesStore } from '@/store/phrasesStore';
import { TPhrasesData, TPhrasesTypes } from '@/types/types/general/phrases';
import * as Sentry from '@sentry/nextjs';

export const useUpdatePhrases = (phrases?: TPhrasesData, type?: TPhrasesTypes) => {
    const setPhrases = usePhrasesStore((state) => state.setPhrases);
    useEffect(() => {
        if (phrases)
            setPhrases(phrases, type).catch((err) =>
                Sentry.captureException(err, { extra: { phrases, type } }),
            );
    }, [setPhrases, phrases, type]);
    return phrases;
};
